import { Link as RLink } from 'react-router-dom';

export interface LinkProps {
  children: any;
  to: string;
}

export function Link(props: LinkProps) {
  return <RLink to={props.to}>
    <span className="underline hover:cursor-pointer text-[#24AAE1]">{props.children}</span>
  </RLink>;
}